import { ControlProps } from 'nuka-carousel';
import beTwMerge from '@/utils/beTwMerge';

interface LeftNavArrowProps extends ControlProps {
  btnClass?: string;
  containerClass?: string;
  containerStyle?: any;
  item: any;
}

export default function LeftNavArrow({
  btnClass,
  containerClass,
  containerStyle,
  previousSlide,
  currentSlide,
  item,
}: LeftNavArrowProps): JSX.Element {
  return (
    <div
      className={beTwMerge(
        'tw-absolute tw-left-6 tw-hidden lg:tw-flex tw-flex-col tw-justify-center tw-z-10 tw-top-0 tw-pointer-events-none',
        item.description ? 'tw-h-[calc(100%-74px)]' : 'tw-h-[calc(100%-46px)]',
        containerClass
      )}
      style={containerStyle}
    >
      <button
        type="button"
        onClick={previousSlide}
        className={beTwMerge(
          'tw-w-11 tw-h-11 tw-border-none tw-rounded-full tw-bg-white tw-drop-shadow-xl tw-pointer-events-auto',
          currentSlide === 0 ? 'tw-hidden' : '',
          btnClass
        )}
        aria-label="Previous"
      >
        <i className="iconfont iconfont-left" />
      </button>
    </div>
  );
}
